import { SymDiaProperty } from '../store/types/prescription';
import { GET_ASSESSMENT_SUMMARY } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface SAVitalsHistory {
    dtobject?: Dtobject;
    values?: ValuesEntity[] | null;
}
export interface Dtobject {
    dt: string;
    tm: string;
}
export interface ValuesEntity {
    name: string;
    vl: string;
}

export type AssessmentSummarySA = {
    sy: AssessmentSummary;
    dy: AssessmentSummary;
    mh: AssessmentSummary;
    notes: AssessmentSummary;
    vitals: {
        id: string;
        name: string;
        unit: string;
        unit_id: string;
        value: string | number;
    }[];
    riskScore?: {
        name: string;
        score: number;
    }[];
};

export type SA = {
    sa?: AssessmentSummarySA;
    qna?: QNA[];
    vitals?: SAVitalsHistory;
    media?: AtOrMediaEntity[] | null;
};

export interface AtOrMediaEntity {
    contentType: string;
    url: string;
}

export interface AssessmentSummaryResponse {
    status: string;
    response?: SA;
}

export interface QNA {
    q: string;
    a?: string | null;
    at?: AtOrMediaEntity[];
    qlist?: QNA[] | null;
}

export type AssessmentSummary = AssessmentSummaryEntity[] | undefined;

export const MH_LH = 'lh';
type LifeStyleMH = {
    type: typeof MH_LH;
    meta?: any;
};

export const MH_MC = 'mc';
type PatientMedicalConsition = {
    type: typeof MH_MC;
    meta?: any;
};

export const MH_FA = 'fa';
type FoodAllergy = {
    type: typeof MH_FA;
    meta?: any;
};

// TODO: ENUM given by FHIR
export const MH_FH_RELATION_MAP: { [k: string]: string } = {
    '': '',
};
export const MH_FH = 'fh';

type FamilyHistory = {
    type: typeof MH_FH;
    meta: {
        who: string;
    };
};

export const MH_PP = 'pp';
type PastProcedure = {
    type: typeof MH_PP;
    meta: {
        notes?: string;
        on?: { yyyy: string; mm: string };
        reportedAt?: string;
    };
};

type Nothing = { type?: string; meta?: any };

export type SA_STATUS = 'present' | 'absent' | 'unknown' | 'suspected';
export type SA_ITEM_TYPE = typeof MH_LH | typeof MH_MC | typeof MH_FA | typeof MH_FH | typeof MH_PP;

export type SA_ITEM_META =
    | PatientMedicalConsition
    | LifeStyleMH
    | FoodAllergy
    | FamilyHistory
    | PastProcedure;

export type AssessmentSummaryEntity = {
    mdbid: string;
    mdbname: string;
    status: SA_STATUS;
    properties: { [k: string]: SymDiaProperty };
} & (SA_ITEM_META | Nothing);

export default (vId: string): Promise<AssessmentSummaryResponse> => {
    return fetchWithRefresh(GET_ASSESSMENT_SUMMARY(vId)).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('GET_ASSESSMENT_SUMMARY failed');
        }
    });
};
